import React from "react";
import { JetSportBox } from "../../../components/BoxView/JetSportBox";
import { BoxHeader2 } from "../../../components/BoxView/BoxHeader2";
import { ConversionMetricsDto } from "../../../../data/models/responses/StatisticsResponses";

interface Props {
  data: ConversionMetricsDto | undefined;
  isLoading: boolean;
}

export function ConversionCard({ data, isLoading }: Props) {
  const ratioPct = (data?.designToOrderRatio ?? 0) * 100;
  const avgOrders = data?.avgOrdersPerDesign ?? 0;
  const avgLogos = data?.avgLogosPerDesign ?? 0;

  return (
    <JetSportBox
      className="opacity-0 animate-fadeIn h-full"
      style={{ animationDelay: "400ms", animationFillMode: "forwards" }}
    >
      <BoxHeader2 className="!py-5 !px-6 border-b border-borderGray">
        <div className="flex flex-col">
          <span className="text-xxs uppercase tracking-[0.22em] text-gray-600 font-semibold">
            Conversion
          </span>
          <span className="text-base font-semibold text-black mt-0.5">
            Funnel efficiency
          </span>
        </div>
      </BoxHeader2>

      <div className="px-6 py-6 flex-1 flex flex-col gap-6">
        <Stat
          label="Design → Order"
          value={isLoading ? "—" : `${ratioPct.toFixed(1)}%`}
          subtitle={
            !isLoading && data
              ? `${data.totalOrders.toLocaleString()} orders / ${data.totalDesigns.toLocaleString()} designs`
              : ""
          }
          isHero
        />
        <div className="grid grid-cols-2 gap-4 pt-2 border-t border-borderGray">
          <Stat
            label="Avg orders per design"
            value={isLoading ? "—" : avgOrders.toFixed(2)}
          />
          <Stat
            label="Avg logos per design"
            value={isLoading ? "—" : avgLogos.toFixed(2)}
          />
        </div>
      </div>
    </JetSportBox>
  );
}

function Stat({
  label,
  value,
  subtitle,
  isHero,
}: {
  label: string;
  value: string;
  subtitle?: string;
  isHero?: boolean;
}) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xxs uppercase tracking-[0.18em] text-gray-600 font-semibold">
        {label}
      </span>
      <span
        className={
          isHero
            ? "text-5xl font-bold tracking-tight leading-none text-black tabular-nums"
            : "text-2xl font-bold tracking-tight leading-none text-black tabular-nums"
        }
      >
        {value}
      </span>
      {subtitle && (
        <span className="text-xs text-gray-600 mt-1">{subtitle}</span>
      )}
    </div>
  );
}
